import React from 'react';
import { createRoot } from 'react-dom/client';
import { BaseCSPLauncher } from '../../../components/baseCSP/baseCSPWrapper';
import { CSPConfigs } from '../cspConfigs';
import { BrandMetaTags } from '../../../cspConfigs/brandMetaTags';
import { initSentry } from '../../../helpers/initSentry';

export const REALPublicCSP = () => (
  <>
    <BrandMetaTags {...CSPConfigs.public.meta} />
    <BaseCSPLauncher {...CSPConfigs.public.tool} />
  </>
);
initSentry({ brand: 'real' });
const rootElement = document.getElementById('app');
const root = createRoot(rootElement);

root.render(<REALPublicCSP />);
